// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modal__container-2OhVJ";
var _4 = "modal__paper-2sjaT";
var _5 = "modal__title-2xFqC";
var _6 = "modal__content-35T-B";
var _7 = "modal__buttons-KrTtr";
var _8 = "emoji-2xlH3";
var _9 = "content-1C15G";
var _a = "errorInfo-3-3OG";
var _b = "errorInfo__title-RJMoY";
var _c = "errorInfo__message-g8Ubj";
var _d = "details__wrapper-2_a8i";
var _e = "details__title-2ZciA";
var _f = "details__container-2ny03";
var _10 = "details-h4eIA";
var _11 = "detail-2k2Zf";
var _12 = "details__button-3x45E";
var _13 = "details__description-2wLCT";
export { _1 as "__esModule", _2 as "mobile", _3 as "modal__container", _4 as "modal__paper", _5 as "modal__title", _6 as "modal__content", _7 as "modal__buttons", _8 as "emoji", _9 as "content", _a as "errorInfo", _b as "errorInfo__title", _c as "errorInfo__message", _d as "details__wrapper", _e as "details__title", _f as "details__container", _10 as "details", _11 as "detail", _12 as "details__button", _13 as "details__description" }
export default { "__esModule": _1, "mobile": _2, "modal__container": _3, "modal__paper": _4, "modal__title": _5, "modal__content": _6, "modal__buttons": _7, "emoji": _8, "content": _9, "errorInfo": _a, "errorInfo__title": _b, "errorInfo__message": _c, "details__wrapper": _d, "details__title": _e, "details__container": _f, "details": _10, "detail": _11, "details__button": _12, "details__description": _13 }
